module.exports = __webpack_public_path__ + "static/media/graph-gesis.97dada4c.gif";